<template>
  <div>
    <TopBar />
    <slot />
    <FooterBase />
  </div>
</template>

<script>
import TopBar from "./../components/TopBar";
import FooterBase from "./../components/Footer";

export default {
  name: "Site",
  components: {
    TopBar,
    FooterBase
  },
  mounted() {
    this.addAuthClassName();
  },
  methods: {
    addAuthClassName() {
      const body = document.body;
      body.className = "";
      body.classList.add("Institution");
    }
  }
};
</script>

<style>
.Institution {
  background-color: #f8f9fa;
}
</style>
